import { render, staticRenderFns } from "./LeftSideIndex.vue?vue&type=template&id=47819ff6&scoped=true&"
import script from "./LeftSideIndex.vue?vue&type=script&lang=js&"
export * from "./LeftSideIndex.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideIndex.vue?vue&type=style&index=0&id=47819ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47819ff6",
  null
  
)

export default component.exports